import { gql } from '@apollo/client'

// Mirrors src/query/export-processing.ts (EXPORT_PROCESSING_QUERY), packaging column set.
export const EXPORT_PACKAGING_PROCESSING_QUERY = gql`
  query PackagingProcessingActivities(
    $first: Int
    $after: String
    $where: ProcessingActivitiesGraphQlFilterInput
    $order: [ProcessingActivitiesGraphQlSortInput!]
  ) {
    packagingProcessingActivities(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        type
        activityName
        processFlow
        additionalSupplementaryInformation
        defaultMaterialLossFactor
        isEndOfLife
        totalProductAndWasteWeight
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        dataQualityCompletenessScore
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        referenceCountryISOCode
        referenceRegionIdentifier
        referenceTechnologyType
        referenceTechnologyProxyContribution
        dataQualityComment
        lastPublishedDate
        researcherName
        isVerified
        verifiedOn
        lastUpdatedName
        updated
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
